import {Component, OnInit, signal, viewChild} from '@angular/core';
import {MatListOption, MatSelectionList} from '@angular/material/list';
import {ActivatedRoute, Router} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {CantaaMessageService} from '../../../service/cantaa-message.service';
import {KeycloakUserService} from '../../../service/keycloak/keycloak-user.service';
import {KeycloakRole} from '../../../model/keycloak/keycloak-role.model';
import {CantaaErrorHandlerService} from '../../../service/cantaa-error-handler.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'wim-user-roles',
  standalone: true,
  imports: [
    MatSelectionList,
    MatListOption,
    MatButton,
    FormsModule,
    TranslateModule
  ],
  templateUrl: './user-roles.component.html',
  styleUrl: './user-roles.component.scss'
})
export class UserRolesComponent implements OnInit {
  selectionList = viewChild<MatSelectionList>('selectionList');

  roles = signal<KeycloakRole[]>([]);
  userKeycloakId = '';

  constructor(private keycloakUserService: KeycloakUserService,
              private route: ActivatedRoute,
              private errorHandler: CantaaErrorHandlerService,
              private messageService: CantaaMessageService,
              private router: Router) {
  }

  async ngOnInit() {
    this.userKeycloakId = this.route.snapshot.paramMap.get('userId')!;
    this.roles.set(await this.fetchKeycloakRoles(this.userKeycloakId));
  }

  private async fetchKeycloakRoles(userId: string) {
    try {
      return await this.keycloakUserService.getRolesForUser(userId);
    } catch (e) {
      this.errorHandler.handleError(e, 'Failed to fetch keycloak roles');
      throw e;
    }
  }

  async onSave() {
    const selectedValues = this.selectionList()?.selectedOptions.selected.map(option => option.value.name);
    console.log('selectedValues', selectedValues);

    const roles = this.roles().map(role => {
      const assigned = selectedValues!.includes(role.name);
      return {
        ...role,
        assigned
      };
    });
    console.log('new roles', roles);
    await this.assignRolesForUser(this.userKeycloakId, roles);
    this.messageService.success('Roles successfully assigned');
    await this.navigateToUserList();
  }

  private async assignRolesForUser(userId: string, roles: KeycloakRole[]) {
    try {
      return await this.keycloakUserService.assignRolesForUser(userId, roles);
    } catch (e) {
      this.errorHandler.handleError(e, 'Failed to assign roles for user');
      throw e;
    }
  }

  async onCancel() {
    await this.navigateToUserList();
  }

  private async navigateToUserList() {
    await this.router.navigate(['../'], { relativeTo: this.route });
  }
}
